import { forwardRef } from 'react';
import filtersStyles from '../css/filters.module.scss';
import CustomTextInput from './customTextInput';

const CustomDropdownSearch = forwardRef<
  HTMLDivElement,
  {
    isOpen: boolean;
    onToggle: () => void;
    options: Array<string>;
    value: string[];
    onChange: (item: string) => void;
    width: string;
    label?: string;
    labelClasses?: string;
    wrapperClasses?: string;
    headClasses?: string;
    placeholderStyle?: string;
    placeholder?: string;
    onSearch?: (searchTerm: string) => void;
    error?: string;
  }
>(({ isOpen, onToggle, options, value, onChange, width, label, labelClasses, wrapperClasses, headClasses, placeholderStyle, placeholder, onSearch, error }, ref) => {
  return (
    <div className={`${filtersStyles.filterWrapper} ${wrapperClasses}`} ref={ref} style={{ width: width }}>
      <div className={`${filtersStyles.filterHead} ${headClasses}`} onClick={onToggle} title={value?.join(', ') || placeholder || ''} style={{ borderColor: error ? '#ef4444' : '' }}>
        {value?.length > 0 ? (
          <div>
            <p style={{ fontSize: '16px' }}>{value?.join(', ')?.length > 37 ? `${value?.join(', ').substring(0, 37)}...` : value?.join(', ')}</p>
          </div>
        ) : (
          <p>
            <span className={`${filtersStyles.label} ${placeholderStyle}`}>{placeholder}</span>
          </p>
        )}
        <img src="/assets/images/chevron-down.svg" alt="chevron" className={`${filtersStyles.chevronIcon} ${isOpen ? filtersStyles.active : ''}`} />
      </div>
      {isOpen && (
        <div className={`${filtersStyles.filterBody} ${filtersStyles.filterBodySearch}`}>
          <div style={{ padding: '8px 8px', backgroundColor: '#ffffffff', position: 'sticky', top: 0, zIndex: 10 }}>
            <CustomTextInput type="text" placeholder="Search..." className={filtersStyles.searchInput} onChange={(e) => onSearch?.(e.target.value)} />
          </div>
          {options.map((item) => (
            <div
              key={item}
              className={`${filtersStyles.filterItem} ${value.includes(item) ? filtersStyles.active : ''}`}
              onClick={() => {
                onChange(item);
              }}
              style={{ padding: '12px 16px', display: 'flex', gap: '10px', alignItems: 'center' }}
            >
              <div className={`${filtersStyles.checkbox} ${value.includes(item) ? filtersStyles.active : ''}`}>
                <div className={`${filtersStyles.checkboxIcon} ${value.includes(item) ? filtersStyles.active : ''}`}></div>
              </div>
              <p>{item}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

CustomDropdownSearch.displayName = 'CustomDropdown';

export default CustomDropdownSearch;
